import { useTranslation } from "react-i18next";
import benefits from "../../assets/benefits.png";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export default function BenefitsSection() {
  const { t } = useTranslation();

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" },
    }),
  };

  return (
    <div
      id="benefits"
      className="min-h-screen bg-white dark:bg-defaultBlack pt-20 px-4 sm:px-6 lg:px-8 dark:text-white"
    >
      <div className="container mx-auto">
        {/* Header Section */}
        <div className="max-w-3xl mb-12">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
            {t("homePage.benefits")}
          </h1>
          <p className="text-lg text-gray-600 dark:text-white/70">
            {t("homePage.title.part1")} {t("homePage.title.part2")}{" "}
            {t("homePage.title.part3")} {t("homePage.paragraph")}.
          </p>
        </div>

        {/* Main Content */}
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left Column - Image */}
          <motion.div
            className="flex items-center h-full"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <img
              src={benefits}
              alt="Woman using mobile app"
              className="w-full h-auto object-cover"
            />
          </motion.div>

          {/* Right Column - Features */}
          <div className="space-y-8">
            {[1, 2, 3].map((num, i) => (
              <motion.div
                key={num}
                className="flex items-start space-x-4 p-6 bg-white dark:bg-white/5 shadow-md rounded-lg border border-defaultBlack/5"
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={i}
              >
                <CheckCircle2 className="w-6 h-6 text-defaultGreen/80 flex-shrink-0 mt-1" />
                {/* <CheckCircle2 className="w-6 h-6 text-defaultGreen/80 flex-shrink-0 mt-1 stroke-inherit fill-defaultGreen/80" /> */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 uppercase flex flex-wrap items-center">
                    {t(`benefitsPage.benefit${num}.title`)}
                    {/* {num === 2 && (
                      <span className="ml-1 px-2 py-1 text-xs font-semibold bg-defaultYellow text-defaultBlack rounded-full align-middle capitalize whitespace-nowrap">
                        {t(`benefitsPage.launchingSoon`)}
                      </span>
                    )} */}
                  </h3>
                  <p className="text-gray-600 dark:text-white/70">
                    {t(`benefitsPage.benefit${num}.text`)}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
